var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.$store.state.cookiesBannerVisible && !_vm.modalVisible
        ? _c("div", { staticClass: "cookies-banner" }, [
            !_vm.modalVisible
              ? _c("span", [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("cookies-banner.banner-text"))
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "text-decoration": "underline"
                      },
                      on: {
                        click: function() {
                          _vm.modalVisible = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("cookies-banner.cookies-policy")))]
                  ),
                  _vm._v(".\n      "),
                  _c(
                    "div",
                    { staticClass: "d-block" },
                    [
                      _c(
                        "base-button",
                        {
                          staticClass: "d-inline-block mx-auto mt-3 mr-4",
                          on: { click: _vm.acceptCookies }
                        },
                        [
                          _c("span", { staticStyle: { color: "white" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("cookies-banner.got-it")) +
                                "\n          "
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "base-button",
                        {
                          staticClass: "d-inline-block mx-auto mt-3",
                          on: { click: _vm.acceptMinimumCookies }
                        },
                        [
                          _c("span", { staticStyle: { color: "white" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("cookies-banner.only-necessary")) +
                                "\n          "
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.modalVisible
        ? _c(
            "base-modal",
            {
              ref: "cookies-modal",
              attrs: {
                title: _vm.$t("cookies-banner.cookies-policy"),
                hideClose: ""
              },
              model: {
                value: _vm.modalVisible,
                callback: function($$v) {
                  _vm.modalVisible = $$v
                },
                expression: "modalVisible"
              }
            },
            [
              _c(
                "div",
                { staticStyle: { padding: "20px", "text-align": "left" } },
                [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("cookies-modal.cookies-4txt"))
                    }
                  }),
                  _vm._v(" "),
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("cookies-modal.cookies-5txt"))
                    }
                  }),
                  _vm._v(" "),
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("cookies-modal.cookies-5table"))
                    }
                  }),
                  _vm._v(" "),
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("cookies-modal.cookies-5clarify")
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("cookies-modal.goToCookiesPolicy")
                      )
                    }
                  }),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "base-button",
                    {
                      staticClass: "mt-3",
                      on: {
                        click: function() {
                          return (_vm.modalVisible = false)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("cookies-banner.accept-btn")) +
                          "\n      "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4553d9e1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4553d9e1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/CookiesBanner.vue
// module id = 1749
// module chunks = 116